<script setup lang="ts" generic="TValue extends string">
defineOptions({
  inheritAttrs: false
})

const model = defineModel<TValue>({ required: true })

withDefaults(
  defineProps<{
    items: Array<{ label: string; value: TValue }>
    label: string
    size?: "xs" | "sm"
  }>(),
  {
    size: "sm"
  }
)
</script>

<template>
  <USelect
    v-bind="$attrs"
    v-model="model"
    :aria-label="label"
    :items="items"
    class="dashboard-filter-select min-w-40 w-full"
    label-key="label"
    :size="size"
    :ui="{ base: 'dashboard-filter-control', trailingIcon: 'text-(--dash-dim)' }"
    value-key="value"
  />
</template>
